module.exports = __webpack_public_path__ + "img/58.6.CODm.b4bd02ac.png";